import styled, { css } from 'styled-components';

const dragActive = css`
    border-color: #78e5d5;
`;

const dragReject = css`
    border-color: #e57878;
`;

export const Container = styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Content = styled.div`
    width: 100%;
    max-width: 1000px;
    margin: 30px;
    background-color: #fff;
    border-radius: 4px;
    padding: 20px;
`;

export const DropContainer = styled.div.attrs({
    className: 'dropzone',
})`
    height: 200px;
    border: 2px dashed #ddd;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;

    transition: height 0.2s ease;

    ${props => props.$isDragActive && dragActive};
    ${props => props.$isDragReject && dragReject};
`;

const messageColors = {
    default: '#999',
    error: '#e57878',
    success: '#78e5d5'
}
export const UploadMessage = styled.p`
    display: flex;
    color: ${props => messageColors[props.type || 'default']};
    justify-content: center;
    align-items: center;
    padding: 15px 0;
`;